module.exports = __webpack_public_path__ + "27a9d56c32e483a12fc1b2bdecd7b36d.pdf";